import React, { useState } from 'react'

import { Button, Header, Image, Dimmer, Grid } from 'semantic-ui-react'

const MyBrandingLogos = (props: IMyBrandingLogosProps) => {
  // Props
  const {
    logoAvatarUrl,
    logoUrl,
    logoWatermarkUrl,
    setShowIconUploadModal,
    setShowFullLogoUploadModal,
    setShowWatermarkUploadModal,
  } = props

  // States
  const [dimmedLogo, setDimmedLogo] = useState(false)
  const [dimmedFullLogo, setDimmedFullLogo] = useState(false)
  const [dimmedWatermark, setDimmedWatermark] = useState(false)

  return (
    <>
      <Grid.Row>
        <Grid.Column width={10}>
          <Header as="h3">
            Upload icon
            <Header.Subheader>
              Your square icon or favicon appears beside your organization name on contributor upload pages (recommend
              225 × 225px).
            </Header.Subheader>
          </Header>
        </Grid.Column>
        <Grid.Column width={2}></Grid.Column>
        <Grid.Column width={4} textAlign="center">
          <Dimmer.Dimmable
            onMouseEnter={() => setDimmedLogo(true)}
            onMouseLeave={() => setDimmedLogo(false)}
            style={{ width: '100px', margin: 'auto' }}
          >
            {/* Add background color in case of white png images */}
            <Image avatar size="small" src={`${logoAvatarUrl}`} />
            <Dimmer active={dimmedLogo} style={{ borderRadius: '50%' }}>
              <Button size="mini" fluid inverted compact basic onClick={() => setShowIconUploadModal(true)}>
                Change
              </Button>
            </Dimmer>
          </Dimmer.Dimmable>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={10}>
          <Header as="h3">
            Full logo
            <Header.Subheader>
              Your complete organization logo is stored separately for future branded upload experiences (recommend
              transparent PNG, 600 × 300px).
            </Header.Subheader>
          </Header>
        </Grid.Column>
        <Grid.Column width={2}></Grid.Column>
        <Grid.Column width={4} textAlign="center">
          <Dimmer.Dimmable
            onMouseEnter={() => setDimmedFullLogo(true)}
            onMouseLeave={() => setDimmedFullLogo(false)}
            style={{ width: '150px', margin: 'auto' }}
          >
            {logoUrl ? (
              <Image src={logoUrl} style={{ maxHeight: '90px', objectFit: 'contain', margin: 'auto' }} />
            ) : (
              <div style={{ padding: '1rem', border: '1px dashed #aaa' }}>No full logo</div>
            )}
            <Dimmer active={dimmedFullLogo}>
              <Button size="mini" fluid inverted compact basic onClick={() => setShowFullLogoUploadModal(true)}>
                Change
              </Button>
            </Dimmer>
          </Dimmer.Dimmable>
        </Grid.Column>
      </Grid.Row>
      {/* Video watermark */}
      <Grid.Row>
        <Grid.Column width={10}>
          <Header as="h3">
            Video watermark
            <Header.Subheader>
              This white transparent PNG appears over rendered videos at 80% opacity. It is deliberately stored
              separately from the colored full logo (recommend 400 × 225px).
            </Header.Subheader>
          </Header>
        </Grid.Column>
        <Grid.Column width={2}></Grid.Column>
        <Grid.Column width={4} textAlign="right">
          <Dimmer.Dimmable
            onMouseEnter={() => setDimmedWatermark(true)}
            onMouseLeave={() => setDimmedWatermark(false)}
            style={{ width: '150px', margin: 'auto' }}
          >
            <Image
              src={`${logoWatermarkUrl}`}
              style={{
                padding: '8px',
                margin: 'auto',
                backgroundColor: '#555',
                backgroundImage:
                  'linear-gradient(45deg, #444 25%, transparent 25%), linear-gradient(-45deg, #444 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #444 75%), linear-gradient(-45deg, transparent 75%, #444 75%)',
                backgroundPosition: '0 0, 0 8px, 8px -8px, -8px 0px',
                backgroundSize: '16px 16px',
              }}
            />
            <Dimmer active={dimmedWatermark}>
              <Button size="mini" fluid inverted compact basic onClick={() => setShowWatermarkUploadModal(true)}>
                Change
              </Button>
            </Dimmer>
          </Dimmer.Dimmable>
        </Grid.Column>
      </Grid.Row>
    </>
  )
}

interface IMyBrandingLogosProps {
  logoAvatarUrl: string
  logoUrl: string | null
  logoWatermarkUrl: string
  setShowIconUploadModal: (arg: boolean) => void
  setShowFullLogoUploadModal: (arg: boolean) => void
  setShowWatermarkUploadModal: (arg: boolean) => void
}

export default MyBrandingLogos
